import { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/reusableComponents/Dialog";
import { Button } from "../../components/reusableComponents/Button";
import { Input } from "../../components/reusableComponents/Input";
import { Label } from "../../components/reusableComponents/Label";
import qualifications from "../../utils/qualifications";
import { message } from "antd";
import axios from "../../axios/AxiosInstance";
import { useNavigate } from "react-router-dom";
import { AlertOctagon } from "lucide-react";
import MultiSelect from "../../components/reusableComponents/MultiSelect";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

function CreateCandidateModal({
  open,
  onOpenChange,
  candidates,
  setCandidates,
}) {
  const [timer, setTimer] = useState(null);
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [clientSearch, setClientSearch] = useState("");
  const [isLoadingClient, setIsLoadingClient] = useState(false);
  const [clients, setClients] = useState([]);
  const [showClientDropdown, setShowClientDropdown] = useState(false);
  const [selectedQualifications, setSelectedQualifications] = useState([]);
  const userId = localStorage.getItem("userId");
  const inputFileRef = useRef(null);
  const clientRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState('');


  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    qualifications: [],
    clients: [],
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (clientRef.current && !clientRef.current.contains(event.target)) {
        setShowClientDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const searchClient = (word) => {
    console.log(word);

    setClientSearch(word);
    if (word.length === 0) {
      setClients([]);
    }
    if (word.length < 3) {
      if (timer) clearTimeout(timer);
    }
    if (word.length >= 3) {
      if (timer) clearTimeout(timer);

      const timer2 = setTimeout(() => {
        setIsLoadingClient(true);
        axios
          .post("client/freelance/find-by-text", { query: word })
          .then((res) => {
            setClients(res.data);
            setShowClientDropdown(true);
            console.log(res.data);
          })
          .catch((e) => console.log(e))
          .finally(() => setIsLoadingClient(false));
      }, 700);
      setTimer(timer2);
    }
  };

  const analyzeCV = async () => {
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const res = await axios.post(
        "/tempworker-candidate/analyze-cv",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      const { firstname, lastname, email, phone, qualifications } = res.data;
      console.log(res.data);

      setFormData((prev) => ({
        ...prev,
        firstname: firstname || prev.firstname,
        lastname: lastname || prev.lastname,
        email: email || prev.email,
        phone: phone || prev.phone,
      }));

      if (qualifications) {
        setSelectedQualifications(qualifications);
      }

      message.success("CV analysé automatiquement.");
    } catch (error) {
      console.error("Erreur lors de l'analyse du CV :", error);
      message.error("Échec de l'analyse du CV.");
    }
  };

  /*  useEffect(() => {
    if (!selectedFile) return;

    console.log("okokokok");

    analyzeCV();
  }, [selectedFile]); */

  const addCandidate = (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    if (!isFormComplete()) {
      message.error("Veuillez remplir tous les champs!");
      setLoading(false);
      return;
    }

    const newPhone = formData.phone.replaceAll(" ", "").replaceAll(".", "");

    // Création de l'objet FormData
    const formPayload = new FormData();
    formPayload.append("firstname", formData.firstname);
    formPayload.append("lastname", formData.lastname);
    formPayload.append("email", formData.email);
    formPayload.append("phone", newPhone);
    formPayload.append(
      "site",
      formData.site,
    );
    formPayload.append("qualifications", selectedQualifications.join(","));

    // fichier
    if (selectedFile) {
      formPayload.append("file", selectedFile); // 'file' doit correspondre à ce que le backend attend
    }

    setTimeout(() => {
      for (let [key, value] of formPayload.entries()) {
        console.log(`${key}:`, value);
      }
    }, 2000);

    axios
      .post("tempworker-candidate/client", formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        const newCandidates = [...candidates, res.data];
        setCandidates(newCandidates);
        setLoading(false);
        onOpenChange(false);
      })
      .catch((e) => {
        setLoading(false);
        if (e.response?.data?.statusCode === 403) {
          localStorage.clear();
          navigate("/login");
          return;
        }
        const message = e.response?.data?.message || "Erreur lors de l'envoi.";
        setErrorMessage(message);  // <-- ici on stocke le message d'erreur
        console.error(e);
      });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file.type === "application/pdf") {
      setSelectedFile(event.target.files[0]);
      //analyzeCV(event.target.files[0]);
    } else {
      message.error("Veuillez ajouter un fichier pdf !");
    }
  };

  const handleClick = () => {
    inputFileRef.current.click();
  };

  const isFormComplete = () => {
    const { firstname, lastname, email, phone } = formData;
    return firstname !== "" && lastname !== "" && email !== "" && phone !== "";
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[550px] p-0 overflow-hidden bg-white rounded-xl">
        <div className="bg-gray-200 py-4 px-6">
          <DialogTitle className="text-xl font-semibold text-black mb-1">
            Ajouter un nouveau candidat
          </DialogTitle>
        </div>

        <form onSubmit={addCandidate} className="space-y-4 p-6 bg-white">
          <div className="grid grid-cols-1 gap-y-4 bg-white">
            {/* Prenom */}
            <div className="space-y-2">
              <Label
                htmlFor="firstname"
                className="text-sm font-medium text-gray-700"
              >
                Prénom
              </Label>
              <Input
                id="firstname"
                value={formData.firstname || ''}
                onChange={(e) =>
                  setFormData({ ...formData, firstname: e.target.value })
                }
                placeholder="Prénom du candidat"
                className="border border-gray-300 rounded-md"
              />
            </div>

            {/* Nom de famille */}
            <div className="space-y-2">
              <Label
                htmlFor="lastname"
                className="text-sm font-medium text-gray-700"
              >
                Nom
              </Label>
              <Input
                id="lastname"
                value={formData.lastname || ''}
                onChange={(e) =>
                  setFormData({ ...formData, lastname: e.target.value })
                }
                placeholder="Nom du candidat"
                className="border border-gray-300 rounded-md"
              />
            </div>

            {/* Email */}
            <div className="space-y-2">
              <Label
                htmlFor="email"
                className="text-sm font-medium text-gray-700"
              >
                Email
              </Label>
              <Input
                id="email"
                value={formData.email || ''}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                placeholder="Email du candidat"
                className="border border-gray-300 rounded-md"
              />
            </div>

            {/* Telephone */}
            <div className="space-y-2">
              <Label
                htmlFor="phone"
                className="text-sm font-medium text-gray-700"
              >
                Téléphone
              </Label>
              <Input
                id="phone"
                value={formData.phone || ''}
                onChange={(e) =>
                  setFormData({ ...formData, phone: e.target.value })
                }
                placeholder="Téléphone du candidat"
                className="border border-gray-300 rounded-md"
              />
            </div>

            <div className="space-y-2 text-gray-400">
              <Label
                htmlFor="phone"
                className="text-sm font-medium text-gray-700"
              >
                Qualifications
              </Label>
              <MultiSelect
                options={qualifications.map((qualif) => ({
                  label: qualif,
                  value: qualif,
                }))}
                placeholder={"Selectionner les qualifications"}
                selected={selectedQualifications}
                setSelected={setSelectedQualifications}
              />
            </div>

             <div className="space-y-2">
              <Label
                htmlFor="site"
                className="text-sm font-medium text-gray-700"
              >
                Site
              </Label>
              <Input
                id="site"
                value={formData.site || ''}
                onChange={(e) =>
                  setFormData({ ...formData, site: e.target.value })
                }
                placeholder="Site"
                className="border border-gray-300 rounded-md"
              />
            </div>

            <div
              onClick={handleClick}
              className="border flex flex-col pt-2 hover:cursor-pointer items-center justify-center border-[#00000040] py-3 text-[#00000040] rounded-md"
            >
              <CloudUploadIcon />
              <p className="mt-2">Ajouter CV</p>
              <p className="text-black">{selectedFile?.name}</p>
              <input
                type="file"
                onChange={(e) => handleFileChange(e)}
                className="hidden"
                ref={inputFileRef}
              />
            </div>
          </div>
 {errorMessage && (
  <div style={{ color: 'red', marginTop: 10 }} className="flex justify-end -mt-10">
    {errorMessage}
  </div>
)}
          <DialogFooter className="flex justify-end mt-6 pt-4 border-t border-gray-100">
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              className="mr-2 border-gray-300"
            >
              Annuler
            </Button>
            <Button
              type="submit"
              className="bg-black mb-5 hover:bg-black text-white font-medium"
            >
              <span>Créer le candidat</span>
            </Button>
     
          </DialogFooter>
            
        </form>
            
      </DialogContent>
    </Dialog>
  );
}
export default CreateCandidateModal;
